// organize-imports-ignore
import 'vite/modulepreload-polyfill'
import 'bootstrap'
import { Application, ControllerConstructor } from '@hotwired/stimulus'
import './polyfill'
import '../css/index.less'

declare global {
  interface Window {
    Stimulus: Application
  }
}

window.Stimulus = Application.start()
Object.entries(
  import.meta.glob(['./controllers/*.[jt]s'], { eager: true, import: 'default' }),
).forEach(([key, controller]) => {
  const controllerKey = key.match(/([a-z0-9-]+)-controller\.[jt]s/)?.[1]
  if (controllerKey) {
    window.Stimulus.register(controllerKey, controller as ControllerConstructor)
  }
})
